<template>
  <div class="joinMain">
    <div class="banner">
      <img src="@/assets/image/joinBanner.png" alt="">
    </div>
    <div class="join_info">
      <h5>运营总监<i></i></h5>
      <div class="item">
        <h6>岗位职责：</h6>
        <ul>
          <li>制定APP的整体内容传播策略和内容营销规划，建设强互动的内容社区氛围，鼓励用户生产优质内容；</li>
          <li>根据平台调性、洞察用户感兴趣的选题方向，产出营销性内容或干货内容（包括视频和文案），提高用户粘性、促进点击与评论量，引导UGC的生成；</li>
          <li>分析内容传播中的各项数据、用户行为与偏好，掌握用户心理，进一步挖掘用户内容需求；</li>
          <li>对用户行为进行引导，发现产品新的机会和改进点，为产品的优化迭代提出建议及解决方案；</li>
          <li>通过不断创新玩法，结合数据分析，推进平台数据增长。</li>
        </ul>
      </div>
      <div class="item">
        <h6>任职要求：</h6>
        <ul>
          <li>2年以上互联网运营及市场工作经验，过往背景以互联网平台运营优先；</li>
          <li>有较强的执行力，以结果为导向，擅长调动社会资源完成运营目标；</li>
          <li>良好的数据分析能力和逻辑思维能力，擅长归纳总结；</li>
          <li>熟悉PGC和UGC内容玩法，了解每个链路的内容输出；</li>
          <li>熟悉主流媒体平台的各种运营方式和推广手段；</li>
          <li>有大互联网公司经验优先考虑。</li>
        </ul>
      </div>
      <div class="more">还有开发岗、产品岗、设计岗、测试岗、运维岗等，等你来！另外推荐人才也有红包领取哦～</div>
    </div>
    <div class="wechatImg">
      <img src="@/assets/image/wechat_join.png" />
    </div>
    <div class="btn" v-clipboard:copy="number" v-clipboard:success="onCopy" v-clipboard:error="onError">复制微信</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      type: null,
      number: 'qudaowuyou-2020'
    }
  },
  created(){
  },
  methods: {
    onCopy () {
      this.$toast("复制成功")
    },
    // 复制失败时的回调函数
    onError () {
      this.$toast("抱歉，复制失败")
    }
  }
}
</script>
<style lang="scss" scoped>
.joinMain {
  padding: 0.426667rem;
  .banner{
    width:100%;
    img{
      width: 100%;
    }
  }
  .join_info{
    h5{
      font-size: 0.48rem;
      font-weight: bold;
      line-height: 20px;
      color: #333;
      position: relative;
      margin: 0.533333rem 0;
      i{
        width: 0.533333rem;
        height: 0.08rem;
        background: #F3474A;
        display: block;
        margin-top: 20px;
      }
    }
    .item{
      margin-bottom: 0.533333rem;
    }
    h6{
      font-size: 0.373333rem;
      font-weight: bold;
      line-height: 20px;
      color: #F3474A;
      opacity: 1;
      margin-bottom: 0.333333rem;
    }
    li{
      font-size: 0.373333rem;
      font-weight: 400;
      color: #666666;
      opacity: 1;
      margin-bottom: 0.266667rem;
      padding-left: 0.266667rem;
      position: relative;
      &::before{
        content: '';
        display: block;
        width: 6px;
        height: 6px;
        background: #F3474A;
        border-radius: 50%;
        position: absolute;
        top: 0.22rem;
        left: 0;
      }
    }
    .more{
      font-size: 0.373333rem;
      font-weight: 500;
      color: #000000;
      font-weight: bold;
    }
  }
  .wechatImg{
    width: 6.853333rem;
    margin: 0.96rem auto 0.8rem;
  }
  .btn{
    text-align: center;
    width: 8.08rem;
    height: 1.173333rem;
    line-height: 1.173333rem;
    background: #F3474A;
    opacity: 1;
    border-radius: 8px;
    margin: 0 auto;
    font-size: 0.426667rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    opacity: 1;
  }
}
</style>